module.exports = __webpack_public_path__ + "05_short_grey.a5995363.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/05_short_grey.png
// module id = uMD4
// module chunks = 0